/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SectionFetchedData } from './SectionFetchedData';
import {
    SectionFetchedDataFromJSON,
    SectionFetchedDataFromJSONTyped,
    SectionFetchedDataToJSON,
    SectionFetchedDataToJSONTyped,
} from './SectionFetchedData';

/**
 * 
 * @export
 * @interface FetchSectionsDataResponseDto
 */
export interface FetchSectionsDataResponseDto {
    /**
     * 
     * @type {Array<SectionFetchedData>}
     * @memberof FetchSectionsDataResponseDto
     */
    fetchedData: Array<SectionFetchedData>;
}

/**
 * Check if a given object implements the FetchSectionsDataResponseDto interface.
 */
export function instanceOfFetchSectionsDataResponseDto(value: object): value is FetchSectionsDataResponseDto {
    if (!('fetchedData' in value) || value['fetchedData'] === undefined) return false;
    return true;
}

export function FetchSectionsDataResponseDtoFromJSON(json: any): FetchSectionsDataResponseDto {
    return FetchSectionsDataResponseDtoFromJSONTyped(json, false);
}

export function FetchSectionsDataResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetchSectionsDataResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fetchedData': ((json['fetchedData'] as Array<any>).map(SectionFetchedDataFromJSON)),
    };
}

export function FetchSectionsDataResponseDtoToJSON(json: any): FetchSectionsDataResponseDto {
    return FetchSectionsDataResponseDtoToJSONTyped(json, false);
}

export function FetchSectionsDataResponseDtoToJSONTyped(value?: FetchSectionsDataResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fetchedData': ((value['fetchedData'] as Array<any>).map(SectionFetchedDataToJSON)),
    };
}

